/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/content-ai-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/content-ai-api-client";
import type { StationConfigUpdateMutationRequest, StationConfigUpdateMutationResponse, StationConfigUpdatePathParams } from "../models/StationConfigUpdate";

export function getStationConfigUpdateUrl(stationId: StationConfigUpdatePathParams["stationId"]) {
  const res = { method: 'PUT', url: `/station-config/${stationId}` as const }  
  return res
}

/**
 * @summary Update station config
 * {@link /station-config/:stationId}
 */
export async function stationConfigUpdate(stationId: StationConfigUpdatePathParams["stationId"], data: StationConfigUpdateMutationRequest, config: Partial<RequestConfig<StationConfigUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<StationConfigUpdateMutationResponse, ResponseErrorConfig<Error>, StationConfigUpdateMutationRequest>({ method : "PUT", url : getStationConfigUpdateUrl(stationId).url.toString(), data : requestData, ... requestConfig })  
  return res.data
}